import type { SxProps, Theme } from "@mui/material/styles";

export const caseFormCardSx: SxProps<Theme> = {
  p: { xs: 2, sm: 2.5, md: 3 },
  mt: 2.5,
  borderRadius: 2,
  backgroundColor: "#FFFFFF",
  border: "1px solid #E6E8EF",
  boxShadow: "0 10px 28px rgba(17, 24, 39, 0.06)",
  "--case-field-height": "52px",
  "--case-field-radius": "8px",
  "& .MuiOutlinedInput-root": {
    minHeight: "var(--case-field-height)",
    backgroundColor: "#FCFCFD",
    borderRadius: "var(--case-field-radius)",
    fontSize: 14,
    transition: "border-color 160ms ease, box-shadow 160ms ease",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D8DDE8",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#B7C0D0",
  },
  "& .MuiOutlinedInput-root.Mui-focused": {
    boxShadow: "0 0 0 3px rgba(249, 115, 22, 0.12)",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#F97316",
    borderWidth: "1px",
  },
  "& .MuiOutlinedInput-input": {
    py: 1.35,
  },
  "& .MuiFormHelperText-root": {
    mx: 0,
    mt: 0.45,
    fontSize: 12,
  },
  "& .MuiRadio-root": {
    py: 0.5,
  },
  "& .MuiSwitch-root": {
    ml: -1,
  },
};

export const caseGridSx: SxProps<Theme> = {
  alignItems: "flex-start",
};

export const caseLabelSx: SxProps<Theme> = {
  mb: 0.65,
  fontSize: 14,
  fontWeight: 700,
  lineHeight: 1.35,
  color: "#1F2937",
  textAlign: "left",
};

export const caseRadioGroupSx: SxProps<Theme> = {
  minHeight: 24,
  mb: 0.55,
  "& .MuiFormControlLabel-root": {
    mr: 2,
  },
  "& .MuiFormControlLabel-label": {
    fontSize: 14,
    fontWeight: 700,
    color: "#1F2937",
  },
};

export const caseNotificationStackSx: SxProps<Theme> = {
  display: "flex",
  gap: { xs: 1.5, md: 0.75 },
  flexDirection: { xs: "row", md: "column" },
  flexWrap: "wrap",
  "& .MuiFormControlLabel-root": {
    m: 0,
  },
  "& .MuiFormControlLabel-label": {
    fontSize: 14,
    fontWeight: 700,
    color: "#1F2937",
  },
};

export const caseMultilineSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    minHeight: 132,
    alignItems: "flex-start",
  },
};

export const caseActionBarSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 2,
  mt: 4,
  pt: 2.5,
  borderTop: "1px solid #EEF0F4",
  flexDirection: { xs: "column-reverse", sm: "row" },
};

export const caseButtonSx: SxProps<Theme> = {
  width: { xs: "100%", sm: 170 },
  height: 44,
  borderRadius: "8px",
  textTransform: "none",
  fontSize: 15,
  fontWeight: 800,
};

export const caseAddButtonSx: SxProps<Theme> = {
  height: 52,
  width: "100%",
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 800,
  fontSize: 15,
};

export const caseTableContainerSx: SxProps<Theme> = {
  mt: 3,
  border: "1px solid #E6E8EF",
  borderRadius: 2,
  overflow: "hidden",
  boxShadow: "none",
};

export const caseTableHeadSx: SxProps<Theme> = {
  backgroundColor: "#F8FAFC",
  "& .MuiTableCell-root": {
    fontWeight: 800,
    color: "#344054",
    borderBottom: "1px solid #E6E8EF",
    whiteSpace: "nowrap",
  },
};

export const caseEmptyCellSx: SxProps<Theme> = {
  py: 4,
  color: "#667085",
  fontWeight: 600,
};

export const caseUploadBoxSx: SxProps<Theme> = {
  border: "1px solid #D8DDE8",
  borderRadius: "8px",
  height: 52,
  display: "flex",
  alignItems: "center",
  px: 1.25,
  backgroundColor: "#FCFCFD",
  minWidth: 0,
};
